import React from 'react';
import { ThemeContext } from 'styled-components';

import roverTheme from '@rover/kibble/themes/roverTheme';
import type { RoverTheme } from '@rover/types/src/RoverTheme';

function useTheme(): RoverTheme {
  const theme = React.useContext(ThemeContext) as RoverTheme;
  return theme || roverTheme;
}

export default useTheme;
